import API from 'utils/api';
import getFormattedValues from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/liquidaciones-empleados-deducciones';

const getValuesAndConfig = (values) => {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
  const formattedValues = getFormattedValues(values, {
    formData: config.headers,
    clean: false,
  });
  return [formattedValues, config];
};

/**
 * GET Liquidaciones Empleados Deducciones
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getLiquidacionesEmpleadosDeducciones = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Liquidacion Empleado Deduccion
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getLiquidacionEmpleadoDeduccion = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Liquidacion Empleado Deduccion
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postLiquidacionEmpleadoDeduccion = async (values) => {
  try {
    const response = await API.post(baseURI, ...getValuesAndConfig(values));
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Liquidacion Empleado Deduccion
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchLiquidacionEmpleadoDeduccion = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, ...getValuesAndConfig(values));
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Liquidacion Empleado Deduccion
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteLiquidacionEmpleadoDeduccion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
